/**
 * RESPONSIBILITY: the Ministries index page's head.
 *
 * Its own section, not a field on the list, so the pencil over the heading opens the
 * heading and the pencil over the grid opens the ministries — the rule every other page
 * on this site follows.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { ABOVE_HINT } from '../hints';

@Section({ name: SectionName.MinistriesHero, label: 'Ministries — page head' })
export class MinistriesHeroSection {
  @Text({ label: 'Subtitle', maxLength: 120, description: ABOVE_HINT })
  eyebrow!: string;

  @Text({ label: 'Title', maxLength: 120, default: 'Church Ministries' })
  heading!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 2 })
  intro!: string;
}
